// import { en } from './en'
import { no } from './no';

// This get's replaced when they change language.
// const lang = en;
const lang = no;

export { lang }